import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-link",
  "use": "icon-cl-link-usage",
  "viewBox": "0 0 13 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 12\" id=\"icon-cl-link\"><path d=\"M7.333 0v1h3.293l-6.27 6.273.704.704 6.273-6.27V5h1V0h-5Zm-5 2c-1.105 0-2 .895-2 2v6c0 1.105.895 2 2 2h6c1.106 0 2-.895 2-2V5l-1 1v4c0 .55-.449 1-1 1h-6c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h4l1-1h-5Z\" fill=\"#45ACE2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol